export abstract class AppImages {
  private static readonly imagesDirPath = '../assets/img';

  static readonly focaliLogoGrey84Path = `${AppImages.imagesDirPath}/logo_focali_grey_84.png`;
  static readonly focaliLogo192Path = `${AppImages.imagesDirPath}/logo_focali_192.png`;
  static readonly focalLogoCircle220Path = `${AppImages.imagesDirPath}/company-logo.png`;
  static readonly focalLogo128Path = `${AppImages.imagesDirPath}/logo_focal_128.png`;
}
